import React from "react";
import values from "lodash/values";
import groupBy from "lodash/groupBy";
import List from "../list/list.jsx";
import PassListItem from "./pass-list-item.jsx";

class PassList extends React.Component {
  render() {
    // grouped by event
    let items = values(this.props.passes);

    return (
      <List
        items={items}
        timeGetter={i => i.created_at}
        ListItem={PassListItem}
        listItemProps={{ initalEditing: this.props.initalEditing }}
        dontBreakIntoSections={true}
        hideDateHeaders={true}
        hidePastHeader={true}
        hideActions={this.props.hideActions}
      />
    );
  }
}

export default PassList;



// WEBPACK FOOTER //
// ./src/app/components/partials/pass-list/pass-list.jsx